<script>
	import Navbar from "./components/Navbar.svelte";
	import Footer from "./components/Footer.svelte";
	import { formMap } from "./stores.js";

	let root = location.protocol + "//" + location.host;
	let formNames = Object.keys($formMap);
	let formURLs = Object.values($formMap);
</script>

<Navbar />

<main>
	<h1>Available forms and questionnaires</h1>

	<ul>
		{#each formNames as formName, i}
			<li><a href={root + formURLs[i]} target="_blank">{formName}</a></li>
		{/each}
	</ul>
</main>

<Footer />
